import { render, staticRenderFns } from "./ShareVideoModal.vue?vue&type=template&id=60b11fe0&scoped=true"
import script from "./ShareVideoModal.vue?vue&type=script&lang=js"
export * from "./ShareVideoModal.vue?vue&type=script&lang=js"
import style0 from "./ShareVideoModal.vue?vue&type=style&index=0&id=60b11fe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b11fe0",
  null
  
)

export default component.exports